import React from 'react';
import { CLegend } from 'src/components/charts/comps';
import { LegendParams } from 'src/components/charts/comps/CLegend/types';
import styled from 'styled-components';
import { useStateSelector } from 'src/redux';

const Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  grid-gap: 4px;

  .faded {
    opacity: 0.5;
  }
`;

interface LegendComposedProps {
  showProjectedA: boolean;
  showProjectedB: boolean;
}
export const LegendComposed: React.FC<LegendComposedProps> = ({ showProjectedA, showProjectedB }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);

  // The two versions share the same palette; Version 2 is the faded overlay on the chart
  // (series rendered at opacity 0.5), so it gets its own legend rendered at the same opacity.
  // Each version keeps a separate legend so the comparison can be told apart. A series type is
  // shown only when that version actually displays it (showProjectedA / showProjectedB).
  const legendsA = [
    { enabled: showProjectedA, params: { title: 'Unmodified Risk', id: 'col_a_base', color: colors.prussianBlue } },
    { enabled: true, params: { title: 'Live Risk', id: 'col_a_live', color: colors.gp1 } },
    { enabled: showProjectedA, params: { title: 'Projected Risk', id: 'col_a_complete', color: colors.brightBlue } },
    { enabled: true, params: { title: 'Risk Tolerance', id: 'leg-car-a', type: 'dash', color: colors.cflowerBlue } },
  ]
    .filter((el) => el.enabled)
    .map((el) => el.params) as LegendParams[];

  const legendsB = [
    { enabled: showProjectedB, params: { title: 'Unmodified Risk', id: 'col_b_base', color: colors.prussianBlue } },
    { enabled: true, params: { title: 'Live Risk', id: 'col_b_live', color: colors.gp1 } },
    { enabled: showProjectedB, params: { title: 'Projected Risk', id: 'col_b_complete', color: colors.brightBlue } },
    { enabled: true, params: { title: 'Risk Tolerance', id: 'leg-car-b', type: 'dash', color: colors.cflowerBlue } },
  ]
    .filter((el) => el.enabled)
    .map((el) => el.params) as LegendParams[];

  return (
    <Div>
      <div>
        <CLegend legends={legendsA} />
      </div>
      <div className="faded">
        <CLegend legends={legendsB} />
      </div>
    </Div>
  );
};
